import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import { TextArea } from '../TextArea';
import { DraftEditor } from './DraftEditor';
import { HtmlEditorMessages } from './HtmlEditor.i18n';
import {
  initializeEditorWith,
  pastePartialTextIntoEditor,
  generateHtmlFrom,
  generateEmptyEditor,
  insertTextIntoTextAreaField,
} from '../../../shared/htmlEditorUtils';


export class HtmlEditor extends React.Component {
  UNSAFE_componentWillMount() {
    const {
      field,
      onEditorStateChange,
    } = this.props;

    if (field.input && field.input.value) {
      const nextEditorState = initializeEditorWith(field.input.value);
      onEditorStateChange(nextEditorState);
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      field,
      mode,
      textToInsert,
      editorState,
      onEditorStateChange,
      textInsertCallback,
    } = this.props;

    // Reinitialize the editor state (aka. the editor content) when the field is reinitialized
    if (nextProps.field.meta && nextProps.field.meta.initial &&
      field.meta.initial !== nextProps.field.meta.initial) {
      const nextEditorState = initializeEditorWith(nextProps.field.meta.initial);
      if (nextEditorState) {
        onEditorStateChange(nextEditorState);
      }
    }

    if (nextProps.textToInsert && textToInsert !== nextProps.textToInsert) {
      if (mode === 'html') {
        // Update the editor content with the injected text
        const nextEditorState = pastePartialTextIntoEditor(nextProps.textToInsert, editorState, textInsertCallback);
        if (nextEditorState) {
          onEditorStateChange(nextEditorState);
          // Synchronize the field input value with the html value of the editor content.
          const html = generateHtmlFrom(nextEditorState);
          field.input.onChange(html);
          if (textInsertCallback) {
            textInsertCallback();
          }
        }
      } else if (mode === 'text') {
        const textAreaCursor = this.contentTextArea.getSelectionRange();
        insertTextIntoTextAreaField(nextProps.textToInsert, field, textAreaCursor, textInsertCallback);
      }
    }
  }

  componentWillUnmount() {
    const emptyEditorState = generateEmptyEditor(this.props.editorState);
    this.props.onEditorStateChange(emptyEditorState);
  }

  handleModeButtonClick = value => () => {
    const {
      field,
      onEditorStateChange,
      onEditorModeChange,
    } = this.props;

    if (onEditorModeChange) {
      onEditorModeChange(value);

      // clicking on the "html" button should update the "EditorState" with the field input value.
      if (value === 'html') {
        const nextEditorState = initializeEditorWith(field.input.value);
        onEditorStateChange(nextEditorState);
      }
    }
  }

  renderSwitch() {
    const {
      mode,
      switchQaTag,
      tokenPicker,
    } = this.props;

    return (
      <div className="row">
        <div className="col-xs-3">
          {
            tokenPicker
          }
        </div>
        <div className="col-xs-3 pull-right">
          <div
            className="btn-group-justified btn-group"
            role="group"
            id={'mode_' + this.props.id}
            data-qa-item={switchQaTag}
          >
            <div className="btn-group" role="group" key="html_button">
                <button
                  type="button"
                  className={'btn btn-default ' + (mode === 'html' ? 'active' : '')}
                  onClick={this.handleModeButtonClick('html')}
                  value="html"
                >
                  <FormattedMessage {...HtmlEditorMessages.buttons.html } />
                </button>
            </div>
            <div className="btn-group" role="group" key="text_button">
                <button
                  type="button"
                  className={'btn btn-default ' + (mode === 'text' ? 'active' : '')}
                  onClick={this.handleModeButtonClick('text')}
                  value="text"
                >
                  <FormattedMessage {...HtmlEditorMessages.buttons.text } />
                </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderEditor() {
    const {
      field,
      mode,
      editorState,
      editorQaTag,
      ariaLabelledBy,
      ariaDescribedBy,
      onEditorStateChange,
      editorClassName,
    } = this.props;

    switch (mode) {
      case 'text':
        return (
          <TextArea
            ref={(c) => { this.contentTextArea = c; }}
            rows={15}
            field={field}
            ariaLabelledby={ariaLabelledBy}
            ariaDescribedby={ariaDescribedBy}
            data-qa-item={editorQaTag}
            noFormGroup
          />
        );
      case 'html':
      default:
        return (
          <DraftEditor
            field={field}
            onEditorStateChange={onEditorStateChange}
            editorState={editorState}
            ariaLabelledby={ariaLabelledBy}
            ariaDescribedby={ariaDescribedBy}
            data-qa-item={editorQaTag}
            editorClassName={editorClassName}
          />
        );
    }
  }

  render() {
    return (
      <div>
        <div className="editor-wrapper">
          {this.renderSwitch()}
        </div>
        {this.renderEditor()}
      </div>
    );
  }
}

HtmlEditor.defaultProps = {
  mode: 'html',
};

HtmlEditor.propTypes = {
  id: PropTypes.string,
  field: PropTypes.object.isRequired,
  editorState: PropTypes.object.isRequired,
  onEditorStateChange: PropTypes.func.isRequired,
  mode: PropTypes.oneOf(['html', 'text']),
  textToInsert: PropTypes.string,
  onEditorModeChange: PropTypes.func,
  ariaLabelledBy: PropTypes.string,
  ariaDescribedBy: PropTypes.string,
  editorQaTag: PropTypes.string,
  switchQaTag: PropTypes.string,
  editorClassName: PropTypes.string,
  tokenPicker: PropTypes.object,
  textInsertCallback: PropTypes.func,
};

